import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Field, Form, Formik } from 'formik';

import DialogComponent from 'app/components/DialogComponent';
import { Box, Button, CircularProgress, Grid, TextField } from '@material-ui/core';

import CustomTextField from '../../components/TextField';
import DefaultTable from '../../components/DefaultTable';
import lineEndpoint from 'app/api/services/lineEndpoint';
import SaveBox from '../../components/SaveBox';
import Loading from 'app/layouts/Loading';
import { fetchSections } from 'app/store/slices/line';
import { Autocomplete, createFilterOptions } from '@material-ui/lab';

const filterOptions = createFilterOptions({
    matchFrom: 'start',
});

function ItinerarySectionModal(props) {
    const dispatch = useDispatch();
    const { open, onClose, showNotification } = props;

    const [loading, setLoading] = useState(false);
    const [loadingSections, setLoadingSections] = useState(false);
    const [pageSize, setPageSize] = useState(5);
    const [page, setPage] = useState(0);
    const [sections, setSections] = useState([]);
    const [allRows, setAllRows] = useState([]);
    const [rows, setRows] = useState([]);
    const [hasError, setHasError] = useState(false);

    const [searchSectionOne, setSearchSectionOne] = useState('');
    const [searchSectionTwo, setSearchSectionTwo] = useState('');
    const [localidadeInicial, setLocalidadeInicial] = useState({});
    const [localidadeFinal, setLocalidadeFinal] = useState({});
    const [nuPisoUm, setNuPisoUm] = useState('');
    const [nuPisoDois, setNuPisoDois] = useState('');
    const [editElement, setEditElement] = useState(null);

    const locationsStore = useSelector((state) => state.line.lineLocations);
    const sectionsStore = useSelector((state) => state.line.lineSections);

    const handleChangePage = (e, page) => {
        setPage(page);
    };

    const handleChangePageSize = (e) => {
        setPageSize(parseInt(e.target.value));
    };

    const handleChangeSearch = (e, type) => {
        if (type === 1) {
            setSearchSectionOne(e.target.value);
        } else {
            setSearchSectionTwo(e.target.value);
        }
    };

    const handleChangeLocation = async (valueParam, type) => {
        if (valueParam?.cdLinhaLocalidade) {
            setHasError(false);
            if (type === 'initial') {
                setLocalidadeInicial(valueParam);
            } else {
                if (localidadeInicial) {
                    if (localidadeInicial.cdLinhaLocalidade === valueParam.cdLinhaLocalidade) {
                        showNotification('A seção 2 deve ser diferente da seção 1.', 'error');
                        setHasError(true);
                        setLocalidadeFinal({});
                        return;
                    }
                    if (sectionIsOk(localidadeInicial, valueParam)) {
                        setLocalidadeFinal(valueParam);
                    }
                }
            }
        }
    };

    const sectionIsOk = (localidadeInicial, localidadeFinal) => {
        const found = sections.find((section) => {
            return (
                section.cdLocalidadeInicial === localidadeInicial.cdLinhaLocalidade &&
                section.cdLocalidadeFinal === localidadeFinal.cdLinhaLocalidade
            );
        });
        if (found) {
            showNotification('Já existe na tabela as seções 1 e 2, favor verificar.', 'error');
            return false;
        }
        const foundReverse = sections.find((section) => {
            return (
                section.cdLocalidadeInicial === localidadeFinal.cdLinhaLocalidade &&
                section.cdLocalidadeFinal === localidadeInicial.cdLinhaLocalidade
            );
        });
        if (foundReverse) {
            if (!window.confirm('Já existe na tabela as seções 1 e 2 ao inverso, deseja incluir mesmo assim?')) {
                return false;
            }
        }
        return true;
    };

    const prepareRows = (list) => {
        let rows = pageSize > 0 ? list.slice(page * pageSize, page * pageSize + pageSize) : list;
        rows = rows.map((row) => {
            const temp = { ...row };
            let backgroundColor = 'transparent';
            if (temp.boAlterado) backgroundColor = '#ffebcf';
            if (!temp.cdLinhaSecao) backgroundColor = '#b8f5b8';
            if (temp.boExcluido) backgroundColor = '#fbcfca';
            temp.deLocalidadeInicial = temp.localidadeInicial?.deNome || '';
            temp.deLocalidadeFinal = temp.localidadeFinal?.deNome || '';
            temp.style = { backgroundColor };
            return temp;
        });
        return rows;
    };

    const handleEdit = (event, data) => {
        if (data.boExcluido) {
            showNotification('Seção não pode ser editada pois está marcada para deleção', 'error');
            return;
        }
        setLocalidadeInicial(data.localidadeInicial);
        setLocalidadeFinal(data.localidadeFinal);
        setNuPisoUm(data.nuPisoUm);
        setNuPisoDois(data.nuPisoDois);
        setEditElement(data);
        setHasError(false);
    };

    const findIndexElement = (data, localInicial, localFinal) => {
        let index = -1;
        if (data) {
            if (data.cdLinhaSecao) {
                index = sections.findIndex((element) => element.cdLinhaSecao === data.cdLinhaSecao);
            } else {
                index = sections.findIndex(
                    (element) =>
                        element.cdLocalidadeInicial === data.cdLocalidadeInicial &&
                        element.cdLocalidadeFinal === data.cdLocalidadeFinal,
                );
            }
        } else {
            if (
                localInicial &&
                Object.keys(localInicial).length > 0 &&
                localFinal &&
                Object.keys(localFinal).length > 0
            ) {
                index = sections.findIndex(
                    (element) =>
                        element.cdLocalidadeInicial === localInicial.cdLinhaLocalidade &&
                        element.cdLocalidadeFinal === localFinal.cdLinhaLocalidade,
                );
            }
        }
        return index;
    };

    const handleDelete = (event, data) => {
        const index = findIndexElement(data);
        if (index >= 0) {
            const temp = [...sections];
            if (temp[index].boExcluido) {
                delete temp[index].boExcluido;
            } else {
                temp[index] = {
                    ...temp[index],
                    boExcluido: true,
                };
            }
            setSections(temp);
            setAllRows(temp);
        }
    };

    const clear = () => {
        setHasError(false);
        setEditElement(null);
        setLocalidadeInicial({});
        setLocalidadeFinal({});
        setNuPisoUm('');
        setNuPisoDois('');
        setSearchSectionOne('');
        setSearchSectionTwo('');
    };

    const isEqual = (element) => {
        if (!element) return false;
        const initialLocationIsEqual =
            Number(element.cdLocalidadeInicial) === Number(localidadeInicial.cdLinhaLocalidade);
        const finalLocationIsEqual = Number(element.cdLocalidadeFinal) === Number(localidadeFinal.cdLinhaLocalidade);
        const nuPisoUmIsEqual = Number(element.nuPisoUm) === Number(nuPisoUm);
        const nuPisoDoisIsEqual = Number(element.nuPisoDois) === Number(nuPisoDois);
        return finalLocationIsEqual && initialLocationIsEqual && nuPisoUmIsEqual && nuPisoDoisIsEqual;
    };

    const onSaveLocalRow = () => {
        const errors = validateForm();
        if (errors.length > 0) {
            showNotification(errors.join('\n'), 'error');
            return;
        }
        if (editElement != null) {
            const index = findIndexElement(editElement);
            if (index >= 0) {
                const temp = [...sections];
                temp[index] = {
                    ...temp[index],
                    boAlterado: true,
                    cdLocalidadeFinal: localidadeFinal.cdLinhaLocalidade,
                    cdLocalidadeInicial: localidadeInicial.cdLinhaLocalidade,
                    nuPisoDois,
                    nuPisoUm,
                    localidadeFinal,
                    localidadeInicial,
                    deLocalidadeFinal: localidadeFinal.deNome,
                    deLocalidadeInicial: localidadeInicial.deNome,
                };
                setSections(temp);
                setAllRows(temp);
                clear();
            }
            return;
        }
        const list = [...sections];
        const newSection = {
            cdLocalidadeFinal: localidadeFinal.cdLinhaLocalidade,
            cdLocalidadeInicial: localidadeInicial.cdLinhaLocalidade,
            localidadeFinal,
            localidadeInicial,
            nuPisoDois,
            nuPisoUm,
        };
        list.unshift(newSection);
        setSections(list);
        setAllRows(list);
        clear();
    };

    const handleCancel = () => {
        onClose();
        clear();
    };

    const handleSave = async () => {
        setLoading(true);
        const response = await lineEndpoint.saveSections({ secoes: sections });
        if (response?.status === 200) {
            setLoadingSections(true);
            setAllRows(response.data);
            dispatch(fetchSections());
            setLoadingSections(false);
            showNotification('Seções salvas com sucesso', 'success');
        }
        setLoading(false);
    };

    const handleSearch = () => {
        let preparedRows;
        if (searchSectionOne !== '' || searchSectionTwo !== '') {
            let slicePage = sections;
            if (searchSectionOne !== '') {
                slicePage = slicePage.filter((r) => {
                    return r.localidadeInicial.deNome.toLowerCase().indexOf(searchSectionOne.toLowerCase()) >= 0;
                });
            }
            if (searchSectionTwo !== '') {
                slicePage = slicePage.filter((r) => {
                    return r.localidadeFinal.deNome.toLowerCase().indexOf(searchSectionTwo.toLowerCase()) >= 0;
                });
            }
            setAllRows(slicePage);
            preparedRows = prepareRows(slicePage);
        } else {
            setAllRows(sections);
            preparedRows = prepareRows(sections);
        }
        setPage(0);
        setRows(preparedRows);
    };

    useEffect(() => {
        (async () => {
            setHasError(false);
            setLoadingSections(true);
            setAllRows(sectionsStore || []);
            setLoadingSections(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    useEffect(() => {
        (async () => {
            setSections(sectionsStore);
        })();
    }, [sectionsStore]);

    useEffect(() => {
        (() => {
            setRows(prepareRows(allRows));
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, pageSize, allRows]);

    const validateForm = () => {
        const errors = [];
        if (
            !localidadeInicial ||
            Object.keys(localidadeInicial).length === 0 ||
            !localidadeFinal ||
            Object.keys(localidadeFinal).length === 0 ||
            nuPisoUm === undefined ||
            nuPisoUm == null ||
            nuPisoUm === '' ||
            nuPisoDois === undefined ||
            nuPisoDois == null ||
            nuPisoDois === ''
        ) {
            errors.push('Favor selecionar a seção 1, seção 2 e informar o valor para os pisos I e II.');
        } else {
            const index = findIndexElement(editElement, localidadeInicial, localidadeFinal);
            if (index >= 0) {
                if (isEqual(editElement)) {
                    errors.push('Não foi alterado o conteúdo dos campos para alterar, favor verificar.');
                } else {
                    if (
                        sections[index].nuPisoUm === Number(nuPisoUm) &&
                        sections[index].nuPisoDois === Number(nuPisoDois)
                    ) {
                        errors.push('Já existe na tabela as seções 1 e 2, favor verificar.');
                    }
                }
            }
        }
        setHasError(errors.length > 0);
        return errors;
    };

    return (
        <DialogComponent title={'Itinerário entre seções'} subtitle={''} open={open} onClose={onClose}>
            <>
                {loading && <Loading />}
                <Formik
                    enableReinitialize
                    initialValues={{}}
                    validationSchema={null}
                    validateOnBlur
                    onSubmit={() => {}}>
                    {() => {
                        return (
                            <Form>
                                <Grid container spacing={1}>
                                    <Grid item xs={12}>
                                        <h4 style={{ marginBottom: 0 }}>Cadastro/Edição</h4>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Field
                                            name="cdLocalidadeInicial"
                                            value={localidadeInicial}
                                            select
                                            size="small"
                                            margin="dense">
                                            {() => {
                                                return (
                                                    <Autocomplete
                                                        filterOptions={filterOptions}
                                                        value={localidadeInicial}
                                                        options={locationsStore}
                                                        getOptionLabel={(option) => option.deNome}
                                                        onChange={(e, v) => handleChangeLocation(v, 'initial')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Seção 1"
                                                                margin={'dense'}
                                                                fullWidth
                                                                variant="filled"
                                                                error={hasError}
                                                            />
                                                        )}
                                                    />
                                                );
                                            }}
                                        </Field>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Field
                                            name="cdLocalidadeFinal"
                                            value={localidadeFinal}
                                            select
                                            size="small"
                                            margin="dense">
                                            {() => {
                                                return (
                                                    <Autocomplete
                                                        filterOptions={filterOptions}
                                                        value={localidadeFinal}
                                                        options={locationsStore}
                                                        getOptionLabel={(option) => option.deNome}
                                                        onChange={(e, v) => handleChangeLocation(v, 'final')}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Seção 2"
                                                                fullWidth
                                                                margin={'dense'}
                                                                variant="filled"
                                                                error={hasError}
                                                            />
                                                        )}
                                                    />
                                                );
                                            }}
                                        </Field>
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Field
                                            component={CustomTextField}
                                            label="Piso I"
                                            name="nuPisoUm"
                                            value={nuPisoUm}
                                            fullWidth
                                            size="small"
                                            margin="dense"
                                            error={hasError}
                                            onChange={(e) => setNuPisoUm(e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                            type="number"
                                            inputProps={{
                                                max: 99999,
                                            }}
                                            onInput={(e) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value))
                                                    .toString()
                                                    .slice(0, 5);
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <Field
                                            component={CustomTextField}
                                            label="Piso II"
                                            name="nuPisoDois"
                                            value={nuPisoDois}
                                            fullWidth
                                            size="small"
                                            margin="dense"
                                            error={hasError}
                                            onChange={(e) => setNuPisoDois(e.target.value)}
                                            InputLabelProps={{ shrink: true }}
                                            type="number"
                                            inputProps={{
                                                max: 99999,
                                            }}
                                            onInput={(e) => {
                                                e.target.value = Math.max(0, parseInt(e.target.value))
                                                    .toString()
                                                    .slice(0, 5);
                                            }}
                                        />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Box mt={1}>
                                            <Button
                                                variant="contained"
                                                color="secondary"
                                                disableElevation
                                                size="large"
                                                margin="dense"
                                                fullWidth
                                                style={{ color: '#fff', padding: '11px 22px', borderRadius: '25px' }}
                                                onClick={() => {
                                                    onSaveLocalRow();
                                                }}>
                                                {editElement == null ? 'Adicionar' : 'Alterar'}
                                            </Button>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Form>
                        );
                    }}
                </Formik>

                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <h4 style={{ marginBottom: 0 }}>Pesquisar</h4>
                    </Grid>
                    <Grid item xs={5}>
                        <Box mb={2}>
                            <TextField
                                fullWidth
                                label="Seção I"
                                variant="filled"
                                value={searchSectionOne}
                                margin="dense"
                                size="small"
                                onChange={(e) => handleChangeSearch(e, 1)}
                                inputProps={{
                                    maxLength: 100,
                                }}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={5}>
                        <Box mb={2}>
                            <TextField
                                fullWidth
                                label="Seção II"
                                variant="filled"
                                value={searchSectionTwo}
                                margin="dense"
                                size="small"
                                onChange={(e) => handleChangeSearch(e, 2)}
                                inputProps={{
                                    maxLength: 100,
                                }}
                            />
                        </Box>
                    </Grid>
                    <Grid item xs={2}>
                        <Box mt={1}>
                            <Button
                                variant="contained"
                                color="secondary"
                                disableElevation
                                size="large"
                                fullWidth
                                margin="dense"
                                style={{ color: '#fff', padding: '11px 22px', borderRadius: '25px' }}
                                onClick={() => {
                                    handleSearch();
                                }}>
                                Buscar
                            </Button>
                        </Box>
                    </Grid>
                    <Grid item xs={12}>
                        {loadingSections && (
                            <Grid item xs={12} style={{ textAlign: 'center' }}>
                                <CircularProgress size={16} />
                            </Grid>
                        )}
                        {!loadingSections && (
                            <DefaultTable
                                columns={[
                                    { id: 0, fieldName: 'cdLinhaSecao', title: 'Cod.' },
                                    { id: 1, fieldName: 'deLocalidadeInicial', title: 'Seção I' },
                                    { id: 2, fieldName: 'deLocalidadeFinal', title: 'Seção II' },
                                    { id: 3, fieldName: 'nuPisoUm', title: 'Piso I' },
                                    { id: 4, fieldName: 'nuPisoDois', title: 'Piso II' },
                                    { id: 5, fieldName: '', title: '' },
                                ]}
                                size="small"
                                rows={rows}
                                onEdit={handleEdit}
                                onDelete={handleDelete}
                                paginationProps={{
                                    rowsPerPageOptions: [5, 10, 25],
                                    count: allRows.length || 0,
                                    rowsPerPage: pageSize,
                                    page: page,
                                    onPageChange: handleChangePage,
                                    onRowsPerPageChange: handleChangePageSize,
                                }}
                            />
                        )}
                    </Grid>
                    <Grid item xs={12}>
                        <SaveBox
                            onCancel={handleCancel}
                            onSave={handleSave}
                            onSaveColor={'secondary'}
                            onSaveStyles={{ color: '#fff' }}
                            removeSpacing={true}
                            firstButtonLabel={'Voltar'}
                        />
                    </Grid>
                </Grid>
            </>
        </DialogComponent>
    );
}

export default ItinerarySectionModal;
